import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-list-item-storno" }
const _hoisted_2 = ["aria-describedby"]


import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import InfoTooltip from '@lmt-rpb/InfoTooltip/InfoTooltip.vue';
import { createTooltip } from '@lmt-rpb/InfoTooltip/tooltip-config';

type Props = {
	offerFeature: boolean;
};
const FLEXIBLE_BOOKING_TEXT = 'Flexibel buchen';
const TOOLTIP_TEXT =
	'Für dieses Hotel gibt es Angebote, die günstig oder kostenlos stornierbar und umbuchbar sind oder bei denen ein solcher flexibler Tarif zubuchbar ist. Die jeweiligen Angebote sind entsprechend gekennzeichnet.';

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemStorno',
  props: {
    offerFeature: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const tooltip = createTooltip();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.offerFeature)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "hotel-list-item-storno__container",
          role: "status",
          "aria-label": "Flexible booking information",
          "aria-describedby": _unref(tooltip).elementId
        }, [
          _createVNode(BaseIcon, {
            class: "hotel-list-item-storno__shield",
            name: "shieldNew",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }),
          _createCommentVNode(" prettier-ignore "),
          _createElementVNode("span", {
            class: "hotel-list-item-storno__text",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(FLEXIBLE_BOOKING_TEXT)),
          _createVNode(InfoTooltip, {
            config: _unref(tooltip),
            placement: "bottom",
            class: "hotel-list-item-storno__tooltip",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(TOOLTIP_TEXT))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["config"])
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})